import { useRef, useState } from 'react'

import ArrowButton from '~/checklist/components/ArrowButton'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

import { QuartarDataType } from '../types/curriculum.types'

import SelectSubject from './SelectSubject'

interface Props {
  isLastQuarter?: boolean
  isQuarteredCurriculum?: boolean
  quarter: QuartarDataType
  quarterIdx: number
  subjectCounter: number
  isHidden?: boolean
  isUSACurriculum?: boolean
}
export function Quarter({
  isLastQuarter,
  isQuarteredCurriculum,
  quarter,
  quarterIdx,
  subjectCounter,
  isHidden = false,
  isUSACurriculum = false,
}: Props): React.ReactElement {
  const [isExpanded, setIsExpanded] = useState(true)

  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const collapsibleRef = useRef<HTMLDivElement>(null)

  return (
    <div
      className={` ${isLastQuarter && isQuarteredCurriculum && !isExpanded ? 'pb-4 md:pb-6' : ''} ${
        isHidden ? 'hidden' : ''
      } `}
    >
      {isQuarteredCurriculum && !isUSACurriculum && (
        <div>
          <button
            className="flex space-x-3 justify-center items-center mx-auto md:hover:scale-110 duration-300"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <p className="text-8 font-bold text-white leading-7 tracking-px">{quarter.subdivisionLabel}</p>
            <ArrowButton color="text-white" expanded={isExpanded} size={isMobile ? 17 : 20} />
          </button>
        </div>
      )}
      {(isExpanded || !isQuarteredCurriculum) && (
        <div className={`${isQuarteredCurriculum ? 'pt-2.5 md:pt-4' : ''}`} ref={collapsibleRef}>
          <SelectSubject quarterNo={quarterIdx} subjectCounter={subjectCounter} subjects={quarter.subjects} />
        </div>
      )}
    </div>
  )
}
